import React from "react";
import { FC } from "react";
import Dashboard from "./screen/Dashboard";
import ProposalDetails from "./screen/ProposalDetails";
import AddProposal from "./screen/AddProposal";
import RegisterProduct from "./screen/RegisterProduct";
import UnderwriterDetails from "./screen/UnderwriterDetails";
import PolicyManagement from "./screen/PolicyManagement";
import InsurerPortalAccessUrls from "./screen/InsurerPortalAccessUrls";
import ContactRegistration from "./screen/ClientRegistration/ContactRegistration";
import { ReactComponent as DashboardIcon } from "./assets/svg/Dashboard.svg";
import { ReactComponent as ProposalListIcon } from "./assets/svg/ProposalList.svg";
import { ReactComponent as CreateProposalIcon } from "./assets/svg/CreateProposal.svg";
import { ReactComponent as UnderwriterIcon } from "./assets/svg/UnderwriterDetails.svg";
import { ReactComponent as RegisterProductIcon } from "./assets/svg/RegisterProduct.svg";
import { ReactComponent as ContactRegistrationIcon } from "./assets/svg/ContactRegistration.svg";
import { ReactComponent as InsurerPortalAccessURLSIcon } from "./assets/svg/InsurerPortalAccessUrls.svg";
import { ReactComponent as PolicyManagementIcon } from "./assets/svg/PolicyManagement.svg";

interface Route {
  key: string;
  title: string;
  path: string;
  enabled: boolean;
  component: FC<{}>;
  index: number;
  icon: FC<{}>;
}

export const routes: Array<Route> = [
  {
    key: "dashboard",
    title: "Dashboard",
    path: `${process.env.PUBLIC_URL}/dashboard`,
    enabled: true,
    component: Dashboard,
    index: 0,
    icon: DashboardIcon,
  },
  {
    key: "contactRegistration",
    title: "Contact Registration",
    path: `${process.env.PUBLIC_URL}/contactRegistration`,
    enabled: true,
    component: ContactRegistration,
    index: 1,
    icon: ContactRegistrationIcon,
  },
  {
    key: "proposalList",
    title: "Proposal List",
    path: `${process.env.PUBLIC_URL}/proposalList`,
    enabled: true,
    component: ProposalDetails,
    index: 2,
    icon: ProposalListIcon,
  },
  {
    key: "createProposal",
    title: "Create Proposal",
    path: `${process.env.PUBLIC_URL}/createProposal`,
    enabled: true,
    component: AddProposal,
    index: 3,
    icon: CreateProposalIcon,
  },

  {
    key: "underwriterDetails",
    title: "Underwriter Details",
    path: `${process.env.PUBLIC_URL}/underwriterDetails`,
    enabled: true,
    component: UnderwriterDetails,
    index: 4,
    icon: UnderwriterIcon,
  },
  {
    key: "registerProduct",
    title: "Register Product",
    path: `${process.env.PUBLIC_URL}/registerProduct`,
    enabled: true,
    component: RegisterProduct,
    index: 5,
    icon: RegisterProductIcon,
  },

  {
    key: "insurerPortalAccessUrls",
    title: "Insurer Portal Access Urls",
    path: `${process.env.PUBLIC_URL}/insurerPortalAccessUrls`,
    enabled: true,
    component: InsurerPortalAccessUrls,
    index: 6,
    icon: InsurerPortalAccessURLSIcon,
  },
  {
    key: "policyManagement",
    title: "Policy Management",
    path: `${process.env.PUBLIC_URL}/policyManagement`,
    enabled: true,
    component: PolicyManagement,
    index: 7,
    icon: PolicyManagementIcon,
  },
];
